import {
  isEmpty,
  validateEmail,
  validateLength,
} from '../../../utility/validation';

const fields = [
  {
    name: 'email',
    type: 'email',
    label: 'email',
    required: true,
    shouldShowError: true,
    validators: [
      {
        type: 'required',
        validator: isEmpty,
      },
      {
        type: 'invalid',
        validator: validateEmail,
      },
      {
        type: 'exceededLength',
        validator: validateLength,
      },
    ],
  },
];

export default fields;
